import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-entitlements',
  templateUrl: './my-entitlements.component.html'
  
})
export class MyEntitlementsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/my-entitlements/my-entitlements.component.ts